import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify/lib/framework';
import { vuetifyThemeLight } from '@/styles/design-tokens';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: { light: vuetifyThemeLight },
        options: {
            customProperties: true
        }
    },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
});
